<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["BirimId", "DonemId", "Sorgulama","AltDonemId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      GelenVeriler:[],
      Prosesler:[],
      TabloVerileri: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi:[],
      donem:"",
      deger: "",
      aciklama: "",
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },

  },

  methods: {



    Get() {
      this.bugun = new Date();
      //alert(this.bugun);

      this.Prosesler = [];

                let Filter = "&UstDonemid="+this.DonemId+"&Donemid=" + this.AltDonemId;
                   
                this.ActionsFilterGet({ Service: "StrRaporlama/GetProsesKurumBazli", Page: this.Page, Filter: Filter }).then((res) => {
                  this.GelenVeriler = res.Data;

                    for (var i=0; this.GelenVeriler.length; i++){ 

                      let varmi= this.Prosesler.filter(notification => notification.Prosesadi.includes(this.GelenVeriler[i].Prosesadi));
       
                      if (varmi.length==0){

                            this.Prosesler.push({"Prosesadi":this.GelenVeriler[i].Prosesadi,"Detay":[this.GelenVeriler[i]]});               
                      } else {
                        varmi[0].Detay.push(this.GelenVeriler[i]);
                      }

                    }
                 
                        
                });



    },

        ExcelExport(table, name){  
           
                if (!table.nodeType) table = this.$refs.gerceklesme_kurum;
                var html =table.innerHTML  
                var ctx = {worksheet: name || 'Worksheet', table:html }
                var a = document.createElement('a');
                a.href = this.uri +this.base64(this.format(this.template, ctx));
                a.download = name + '.xls';
                a.click();  
        
  
      }, 




  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
  <div>
        <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="
                ExcelExport(
                  'Gerçekleşme Oranları(Kurum Bazlı)',
                  'Gerçekleşme Oranları(Kurum Bazlı)',
                )
              "
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
        </div>


  
    <div ref="gerceklesme_kurum" class="table-responsive">
      

    <div class="table-responsive">
      <table style="width:100%">
        <tr>
          <td colspan="5" style="text-align: center;">
              <div> <h4>{{donem.Aciklama}} Gerçekleşme Oranları (Kurum Bazlı) </h4></div>
          </td>
        </tr>

    
    </table>
    <br>

    <template  v-for="(tablo,index) in Prosesler"  >
    <table  :key="index" style="border: 1px solid; border-collapse: collapse; " border="1" class="table  table-md table-bordered border-success mb-0"  >

      <thead class="table-light" style="text-align: center;">

       <tr style="text-align: center; font-weight: bold;">
        <th style="width:%50">
          {{ tablo.Prosesadi }}
         </th>
        <th>Veri Girişi Yapan Birim Sayısı</th>
        <th>Hedef {{ yil }}</th>
        <th>Gerçekleşme {{ yil }}</th>
        <th>Gerçekleşme Oranı {{ yil }}</th>
       </tr>
      </thead>
      <tbody>
      <tr v-for="(Data,index) in tablo.Detay" :key="index">
      <td>{{ Data.Tabloadi }}</td>
      <td style="text-align: center;">{{Data.Verigirisiyapan}}</td>
      <td style="text-align: center;">{{Data.Hedef}}</td>
      <td style="text-align: center;">{{Data.Gerceklesme}}</td>
      <td style="text-align: center;" v-if="Data.Hedef != 0">{{isNaN((Data.Gerceklesme*100)/Data.Hedef) ? 0 : ((Data.Gerceklesme*100)/Data.Hedef).toFixed(2)}} %</td>
      <td style="text-align: center;" v-if="Data.Hedef == 0">-</td> 
    </tr>
      <tr>
        <td colspan="4"><b>Toplam Gerçekleşme Oranı</b></td>
        <td style="text-align: center;" v-if="tablo.Detay.reduce((total, Data) => total + Data.Hedef, 0) != 0 && tablo.Detay.reduce((total, Data) => total + Data.Gerceklesme, 0) != 0"><b>{{((tablo.Detay.reduce((total, Data) => total + Data.Gerceklesme, 0)*100)/ tablo.Detay.reduce((total, Data) => total + Data.Hedef, 0)).toFixed(2)}}%</b></td>
      </tr>
     
    </tbody>
    </table>
  </template>
    </div>
    
    </div>
  </div>
</template>
